export default {
  'm': {
    'uploading': '업로드 중...',
    'upload_failed': '업로드 실패',
    'EnterID': '클릭하여 BuzzCast ID를 입력하세요',
    'select-specifications': '클릭하여 충전 규격을 고르세요',
    'check-account': '충전 계정 확인',
    'whatID': 'BuzzCast ID는 뭐예요?',
    'getID': 'BuzzCast ID를 입력하세요',
    'maskgetID': 'BuzzCast ID를 입력하세요',
    'toastTips-format-error': '입력 오류',
    'toastTips-no-exist': '해당 ID 없음',
    'toastTipsPlease': '먼저 충전 계정을 확인하세요',
    'common-problem': '자주 묻는 질문',
    'transaction-succeeded': '지불 성공',
    'transaction-failed': '지불 실패',
    'transaction-cancel': '지불 취소',
    'whether-account': '1.충전 완료 후 결과를 어떻게 확인할 수 있을까요?',
    'answer-whether-account': '충전 완료 후 앱으로 [내]-[지갑]에서 다이아몬드를 확인할 수 있습니다',
    'no-account': '2.충전 완료 후에 결제 상품이 지급되지 않으면 어떻게 해요?',
    'answer-no-account': '앱의 [소식]-[공식 소식]-[피드백과 도움]에서 질문을 제출하고 다음과 같은 정보를 제공해 주시면 저희 고객센터에서 도와드리겠습니다.',
    'recharge-money': '1.충전 금액과 계정 ID',
    'recharge-time': '2.충전 시간과 날짜',
    'recharge-shot': '3.지불 성공 프린트스크린',
    'recharge-wrong': '3.계정이나 금액을 잘못 충전하면 어떻게 해요?',
    'answer-recharge-wrong': '지불 비밀번호를 입력하시기 전에 반드시 충전계정의 ID와 충전금액 을 꼼꼼히 확인하신 후 구입하시기 바랍니다. 만약 잘못 충전하면 환불할 수 없습니다. 실제 충전된 ID의 사용자와 연락을 시도하여 보상하고자 하는지 여부를 상대방과 협상할 수 있습니다.',
    'refund': '4.환불',
    'answer-refund': '죄송합니다! BuzzCast는 환불 불가합니다.',
    'buy-enter-link': '다이아몬드를 구입하시면 링크를 통해 충전할 수 있습니다. <a class="web-link" href="https://pay.buzzcast.info">https://pay.buzzcast.info</a> 링크를 모바일 브라우저에 복사하여 구매 페이지로 들어가 계정을 체크한 후, 해당 충전 규격을 선택하고 적절한 지불 방식을 통해 됩니다! 혜택이 많아요!',
    'buy-notice-a': '주의:<a>{msg}</a> 는 BuzzCast 에서 유일한 공식 다이아몬드 구입 웹 인터넷 주소입니다',
    'replace': '교체',
    'sureBtn': 'OK',
    'pay-style': '지불 방법 선택',
    'goBack': '홈페이지로 돌아 가기',
    'toastTips': 'BuzzCast ID를 입력하세요',
    'rechargeFAQ_title': '자주 묻는 질문',
    'PayStatusSuccess_title': '지불 성공',
    'PayStatusFail_title': '지불 실패',
    'PayStatusCancel_title': '지불 취소',
    'Diamonds_title': '{msg} 다이아몬드 충전 공식 사이트',
    'buy-notice': 'pay.buzzcast.info 는 BuzzCast의 유일한 공식 다이아몬드 구매 웹 사이트입니다 고객 서비스 문의는 [메시지]-[공식 뉴스]-[피드백 및 도움말]로 이동하십시오.',
    'RechargeHelp_title': '재충전 도움말',
    'feedback_and_help': '피드백 및 도움말',
    'problem_screenshot': '질문 스크린샷/화면 녹화({msg})',
    'problem_description': '질문 설명',
    'problem_description_placeholder': '발생한 질문을 설명하십시오',
    'optional': '선택사항',
    'required': '필수의',
    'openAPP': 'BuzzCast APP 열기',
    'buy-diamonds-tit': '다이아몬드 서비스 구매',
    'description': 'BuzzCast 의 유일한 공식 다이아몬드 충전 사이트입니다. BuzzCast 는 국제형 사교 소프트웨어이며, 전세계 150개 이상의 국가 및 지구의 사용자는 BuzzCast 를 사용하고 있습니다',
    'keywords': 'BuzzCast 충전, BuzzCast 다이아몬드 충전,BuzzCast 공식충전,BuzzCast 공식충전사이트',
    'payforType': ' 충전 방법',
    'trueText': 'OK',
    'falseText': '취소',
    'alertShowTxt1': '',
    'alertShowTxt3': '를 사용하여',
    'alertShowTxt5': '다이아몬드를 충전 하시겠습니까?',
    'EnterIDTip': '{msg} 빠른 충전',
    'scanLogin': '계정 개인 정보 및 보안을 위해 코드를 스캔하여 로그인하십시오.',
    'scanTip': '팁 : BuzzCast "개인 센터 / 역학"의 오른쪽 상단 모서리에있는 "스캔"을 클릭하여 코드를 스캔하여 로그인합니다. 동시에 QR 코드 스크린 샷을 식별하여 로그인 할 수 있습니다.',
    'scanVersion': 'BuzzCast를 %s 버전으로 업그레이드하고 코드를 스캔하여 로그인하십시오.',
    'delAccount': '계정 삭제',
    'logout': '로그아웃',
    'submit': '제출',
    'email_place_holder': '편지함을 입력하십시오',
    'fill_in_email_address': '이메일 주소를 기입해주세요',
    'fill_in_all_required': '질문 설명을 입력하세요',
    'order_exception_notice': '따뜻한 알림: 비정상적인 충전 주문에 대해 주문 번호 또는 청구서 스크린샷을 제공해야 합니다',
    'cannot_read_file': '파일을 읽을 수 없습니다',
    'submitting': '제출 중...',
    'submit_failed': '제출 실패',
    'contact_email': '이메일 연락처',
    'provide_email': '결제 알림을 받으려면 이메일 주소를 입력하세요',
    'email_address': '이메일 주소',
    'sel_country_area': '국가/지역 선택',
    'search_for': '검색',
    'login': '로그인',
    'scan_login': '스캔 코드 로그인',
    'account_password_error': '번호가 틀린',
    'user_frozen': '이 사용자는 금지되었습니다.',
    'account_no_reg': '계정이 등록되지 않았습니다',
    'login_no': '로그인하지 않았습니다',
    'login_after_recharge': '로그인 후 재충전 할 수 있습니다',
    'scan_login_lesson': '코드 스캔 튜토리얼 로그인 로그인',
    'scan_login_desc': '코드 로그인을 스캔하는 방법은 재충전 웹 사이트에 신속하고 안전하게 실현할 수 있습니다. 다음 두 가지 방법은 로그인 코드를 검색하는 방법을 각각 도입합니다.',
    'scan_login_a_title': 'QR 코드의 스크린 샷을 인식하여 로그인하십시오',
    'scan_login_a_p1': '1. 단일 장치의 시나리오를 사용하는 것이 더 적합합니다. 사용자는 재충전 웹 사이트의 로그인 페이지를 입력하고 클릭하여 클릭하여 "로그인 코드를 스캔"하고 로그인 QR 코드가 표시된 페이지의 스크린 샷을 찍고 앨범을 저장합니다. (스크린 샷 기능은 다른 장치에 대해 약간 다릅니다. 스크린 샷 기능의 작동 지침을 직접 검색 할 수 있습니다)',
    'scan_login_a_p2': '2. BuzzCast 앱을 열고 "개인 센터"또는 "동적"기능 모듈을 통해 오른쪽 상단 모서리에서 "스캔"을 클릭하여 코드 스캔 기능 모듈을 입력하십시오.',
    'scan_login_a_p3': '3. "앨범 선택"을 클릭하고 앨범 사용 권한을 허용하고 저장된 QR 코드 로그인 페이지 스크린 샷을 선택하고 "로그인"확인 버튼을 클릭 한 후에는 브라우저로 돌아가고 잠시 대기하면 페이지가 자동으로 사용자로드됩니다. 정보.',
    'scan_login_b_title': 'QR 코드를 검색하여 로그인하십시오',
    'scan_login_b_p1': '1. 여러 장치를 사용하는 것이 더 적합합니다. 사용자는 재충전 웹 사이트의 로그인 페이지로 들어가고 클릭하여 "스캔 코드 로그인',
    'scan_login_b_p2': '2. 다른 장치에서 BuzzCast 앱을 열고 "개인 센터"또는 "동적"기능 모듈로 이동하여 오른쪽 상단 모서리에서 "스캔"을 클릭하여 코드 스캔 기능 모듈을 입력하십시오.',
    'scan_login_b_p3': '3. 코드 스캔 상자에 코드 스캔 로그인 페이지의 QR 코드와 정렬 페이지에서 시스템이 인식 한 후 "로그인"확인 버튼을 클릭합니다 (코드를 스캔 할 때 장치간에 특정 거리를 유지하는 것이 좋습니다. 시스템이 인식 할 수 있도록). 잠시 후 페이지는 자동으로 사용자 정보를로드합니다.',
    'scan_login_lesson_end': '위의 내용은 코드 로그인을 스캔하기위한 자습서 가이드입니다. 나는 당신을 도울 수 있기를 바랍니다. 고객서비스 상담의 경우 앱메시지-공식 뉴스-피드백과 도움말을 입력하십시오.',
    'or': '또는',
    'input_phone_num': '전화 번호는 비워 둘 수 없습니다',
    'input_email': '이메일 주소를 입력하십시오',
    'input_password': '비밀번호 입력',
    'log_in_using_Facebook': '페스북으로 로그인',
    'log_in_using_Google': '구글로 로그인',
    'account_or_pwd_error': '잘못된 계정 또는 비밀번호',
    'pay_fail_system_risk': '거래 실패 : 시스템 비정상',
    'recharge_fail_risk_network': '충전에 실패했습니다. 고위험 네트워크 환경에 있거나 다른 이유 때문일 수 있습니다. 충전에 도움이 필요하시면 문의해 주세요.',
    'friendly_tip': '따뜻한 팁',
    'i_got_it': '알았다',
    'android_fblogin_tip': 'Facebook은 더 이상 Android 내장 브라우저에서 인증 로그인을 지원하지 않으므로 이 방법으로 로그인할 때 로그인하지 못할 수 있습니다. 이러한 유형의 로그인 문제가 발생하면 Chrome 브라우저를 사용하여 액세스하십시오.',
    'recharge_tip': '특정 금액의 다이아몬드가 계정에 입금된 경우 실제 충전 금액이 적용됩니다',
    'charge': '충전',
    'link_add_mainpage': '다음 재로드를 위해 홈 화면에 대한 링크 추가',
    'click_me_to_add': '추가하려면 나를 클릭하십시오.',
    'user_has_delete': '사용자가 취소되었습니다',
    'support_contant_whatsapp': '지원이 필요한 경우 {msg} App 의 고객 서비스에 문의하십시오: 1924383',
    'buy_balance': '구매 가능한 잔액:',
    'official_coin_seller': '공식 코인 가맹점',
    'paystyle_unavailabel_change_other': '시스템이 비정상적입니다. 이 결제 수단은 일시적으로 사용할 수 없습니다. 다른 결제 수단으로 변경할 수 있습니다.',
    'failedPay': '결제 문제 발생, 재결제',
    "copied": "복사됨",
    "reseller": "중개인",
    "netword_busy_try": "네트워크가 바쁩니다. 다시 시도하십시오",
    "placecommen": '검색어 입력',
    "app_all_v2": '모두',

		"use_phone_login": `휴대폰으로 로그인`,
    "use_email_login": `이메일로 로그인`,
    "device_is_more": "이 기기의 등록 계정 수가 상한에 도달했습니다.",
    "Operation_failed": "해당 기기는 계정 위반으로 영구 정지되었습니다",
    "connection_fail_retry_feedback": "연결 실패. 네트워크가 원활한지 확인하고 다시 시도해 주세요. 계속해서 오류가 발생하는 경우 저희에게 알려주시면 최대한 빨리 해결해 드리겠습니다.",
    "fawry_recharge_failed": "{method}를 통한 ${msg} 충전에 실패했습니다.",
    "feedback": "피드백",
    "problem_feedback": "피드백",
    "recommended_recharge_methods": "권장 결제 수단",
    "try_recharge_methods": "다음 방법을 사용하여 충전을 시도해 주세요. 여전히 문제가 발생하면 아래 \"{feedback}\" 버튼을 클릭하여 연락 주세요.",
    "unable_recharge": "충전할 수 없습니다",
    "submitted_successfully": "성공적으로 제출",
    "feedback_success_tip": "의견을 보내주셔서 감사합니다. 24시간 이내에 최대한 빨리 처리하겠습니다.",
    "completed": "완료",
    'contact_information': '연락처(선택사항)',
    'pay_failed': '결제 실패',
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/ko.js